export default __webpack_public_path__ + "static/media/UserLoginMusic.31e40c62.mp3";